import { z } from "zod";

export const userRoleSchema = z.enum(["admin", "member", "viewer"]);

export const userSchema = z.object({
  email: z.email(),
  id: z.string().min(1),
  name: z.string().min(1),
  role: userRoleSchema,
});

export const sessionSchema = z.object({
  expiresAt: z.number().int().nonnegative(),
  issuedAt: z.number().int().nonnegative(),
  token: z.string().min(1),
  user: userSchema,
});

export type UserRole = z.infer<typeof userRoleSchema>;
export type AuthUser = z.infer<typeof userSchema>;
export type AuthSession = z.infer<typeof sessionSchema>;
